import { Type } from '@angular/core';
import { CollectionFilterAutocompleteComponent } from './filter-autocomplete.component';
import { CollectionFilterCheckboxComponent } from './filter-checkbox.component';
import { CollectionFilterDateRangeComponent } from './filter-date-range.component';
import { CollectionFilterIdsComponent } from './filter-ids.component';
import { CollectionFilterInputComponent } from './filter-input.component';
import { CollectionFilterListComponent } from './filter-list.component';
import { CollectionFilterSearchComponent } from './filter-search.component';

export const COLLECTION_FILTER_COMPONENT_REGISTRY_MAP: {
  [type: string]: Type<any>;
} = {
  checkbox: CollectionFilterCheckboxComponent,
  daterange: CollectionFilterDateRangeComponent,
  input: CollectionFilterInputComponent,
  list: CollectionFilterListComponent,
  search: CollectionFilterSearchComponent,
  autocomplete: CollectionFilterAutocompleteComponent,
  ids: CollectionFilterIdsComponent,
};
